<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "SimuladorContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
		drawer: false,
		group: null,
		value: 0,
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("comissao_vendas")) {
				m.push({
					titulo: "* Simulador Salário",
					titulo_app: "Simulador Salário",
					icon: "mdi-shopping-outline",
					to: "/comissao/simulador",
					tooltip: "Simulador de salário",
				});
			}

			if (this.permissao("comissao_vendas")) {
				m.push({
					titulo: "* Vendas",
					titulo_app: "Vendas",
					icon: "mdi-file-document-outline",
					to: "/comissao",
					tooltip: "Acompanhamento de vendas",
				});
			}

			if (this.permissao("comissao_vendas")) {
				m.push({
					titulo: "* Configuração",
					titulo_app: "Configuração",
					icon: "mdi-file-document-outline",
					to: "/comissao/configuracao",
					tooltip:
						"Configuração de metas e regras de comissionamento",
				});
			}

			if (this.permissao("comissao_vendas")) {
				m.push({
					titulo: "* Dashboard BI",
					titulo_app: "Dashboard BI",
					icon: "mdi-file-document-outline",
					to: "/comissao/bi",
					tooltip: "Dashboard com BI de acompanhamento de vendas",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>